// @ts-nocheck
import { PROXY_URL, callEngineTracesUrl } from '@/utilities/constant';

function unwrapTracesPayload(raw: any) {
  if (!raw || typeof raw !== 'object') return null;
  if (Array.isArray(raw.traces)) return raw;
  if (raw.data && Array.isArray(raw.data.traces)) return raw.data;
  if (Array.isArray(raw.data)) return { traces: raw.data, count: raw.data.length };
  return null;
}

async function fetchViaProxy(url: string) {
  const res = await fetch(PROXY_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      url,
      method: 'GET',
      headers: JSON.stringify({}),
    }),
  });
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') ? await res.json() : await res.text();
  if (typeof body === 'string') {
    throw new Error(body.slice(0, 180) || `Proxy returned ${res.status}`);
  }
  if (body?.error) {
    throw new Error(String(body.error));
  }
  const payload = unwrapTracesPayload(body?.data) || unwrapTracesPayload(body);
  if (!payload) {
    const status = body?.status || res.status;
    throw new Error(`Traces proxy returned ${status || 'an empty response'}`);
  }
  return payload;
}

async function fetchDirect(url: string) {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Traces API returned ${res.status}`);
  }
  const body = await res.json();
  const payload = unwrapTracesPayload(body);
  if (!payload) throw new Error('Traces API returned an empty response');
  return payload;
}

function localDevTracesUrl(callSid: string) {
  if (typeof window === 'undefined') return '';
  const { hostname, origin } = window.location;
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') return '';
  return `${origin}/sipDetails/api/v1/calls/${encodeURIComponent(callSid)}/traces`;
}

export async function fetchCallEngineTraces(callSid: string) {
  const sid = String(callSid || '').trim();
  if (!sid) throw new Error('Missing call SID');
  const url = callEngineTracesUrl(sid);
  const errors: string[] = [];

  try {
    return await fetchViaProxy(url);
  } catch (err: any) {
    errors.push(err?.message || 'proxy failed');
  }

  try {
    return await fetchDirect(url);
  } catch (err: any) {
    errors.push(err?.message || 'direct fetch failed');
  }

  const localUrl = localDevTracesUrl(sid);
  if (localUrl) {
    try {
      return await fetchDirect(localUrl);
    } catch (err: any) {
      errors.push(err?.message || 'local sipDetails proxy failed');
    }
  }

  throw new Error(errors[0] || 'Failed to load call-engine traces');
}
